import { useMemo } from 'react';
import { useKubernetesObjects } from '@backstage/plugin-kubernetes-react';

const ARGOCD_BASE: Record<string, string> = {
  dev: 'https://argocd.dev.dtcloudhosting.com',
  qa: 'https://argocd.qa.dtcloudhosting.com',
  stg: 'https://argocd.stg.dtcloudhosting.com',
  prd: 'https://argocd.prd.dtcloudhosting.com',
};

const BITBUCKET_WORKSPACE = 'discounttire';

export function useRomeServiceData(
  serviceName: string,
  serviceKey: string,
  appKey: string,
  teamKey: string,
  environment: string,
  serviceType: string,
  annotations?: Record<string, string>,
  entity?: any,
) {
  const { kubernetesObjects, loading } = useKubernetesObjects(entity);

  const env = environment?.toLowerCase() ?? 'dev';

  const kongEnabled = annotations?.['rome.io/kong-enabled'] === 'true';

  const kongPath = annotations?.['rome.io/kong-path'] ?? '';

  const autoscaling = annotations?.['rome.io/autoscaling'] === 'true';

  const iamRole = annotations?.['rome.io/iam-role'] === 'true';

  const { cluster, pods, runningPods, imageTag } = useMemo(() => {
    const matchedCluster = kubernetesObjects?.items?.find(
      (item: any) => item.cluster?.name === `dt-shared-${env}`,
    );

    const clusterPods =
      matchedCluster?.resources
        ?.filter((resource: any) => resource.type === 'pods')
        ?.flatMap((resource: any) => resource.resources ?? []) ?? [];

    const runningPodCount = clusterPods.filter(
      (pod: any) => pod.status?.phase === 'Running',
    ).length;

    const latestImageTag = clusterPods[0]?.spec?.containers?.[0]?.image ?? '';

    return {
      cluster: matchedCluster,
      pods: clusterPods,
      runningPods: runningPodCount,
      imageTag: latestImageTag,
    };
  }, [kubernetesObjects, env]);

  const argocdBase = ARGOCD_BASE[env] ?? ARGOCD_BASE.dev;

  const argocdUrl = `${argocdBase}/applications/argocd/${appKey}-${serviceKey}`;

  const bitbucketUrl = `https://bitbucket.org/${BITBUCKET_WORKSPACE}/tf-ws-eks-${teamKey}-${appKey}-${serviceKey}`;

  const apiDocsUrl = `https://${serviceKey}.discounttire.com/swagger`;

  return {
    loading,

    serviceKey,
    appKey,
    environment: env,
    serviceType,

    status: runningPods > 0 ? 'Healthy' : 'Unavailable',

    kongEnabled,
    kongPath,
    autoscaling,
    iamRole,

    podCount: runningPods,

    imageTag,

    argocdUrl,
    bitbucketUrl,
    apiDocsUrl,
  };
}
